import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ModalIds } from "@/constants";
import { useModal } from "@/hooks";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { InfoCircleIcon, StarFilledIcon } from "@gemini/icons";
import { TagInfoModal } from "./TagInfoModal";
export const HdExclusiveTag = () => {
    const { t } = useI18n();
    const { open, isOpen, toggle } = useModal(false, ModalIds.TAG_INFO);
    const displayTagInfo = (e) => {
        e.preventDefault();
        e.stopPropagation();
        open();
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { as: "button", paddingHorizontal: "spacing.8", paddingVertical: "spacing.2", borderWidth: "borderWidth.none", cursor: "pointer", borderRadius: "radius.rounded", marginRight: "spacing.8", backgroundColor: "color.surface.brand.secondary.default", color: "color.content.constant.white.default", typography: "typography.body.14.regular", display: "inline-flex", alignItems: "center", gap: "spacing.4", onClick: (e) => displayTagInfo(e), children: [_jsx(StarFilledIcon, { color: "color.surface.brand.primary.default", size: "sizing.16" }), _jsx(Box, { as: "span", children: t("tags.hd_exclusivity.label") }), _jsx(InfoCircleIcon, { size: "sizing.16", color: "color.content.constant.white.default", position: "relative" })] }), _jsx(TagInfoModal, { isOpen: isOpen, toggle: toggle })] }));
};
